const EXPORT_EXCEL_LIGNE_COMMANDE_ACHAT = 'lignescommandeachat';

export default EXPORT_EXCEL_LIGNE_COMMANDE_ACHAT;

export const TYPE_EDITION_CMD = 'CommandeAchatFournisseur';
export const LISTE_CHOICE_EDITION_COMMANDE = [
  {
    typeEdition: '',
    libelle: 'detailCommandeAchatFournisseur.edition.commandeWithLieuxLivraison',
    typeDonnee: TYPE_EDITION_CMD,
  },
  {
    typeEdition: '',
    libelle: 'detailCommandeAchatFournisseur.edition.lieuxLivraison',
    typeDonnee: TYPE_EDITION_CMD,
    parametresAdditionnels: {
      LieuxLivraisonUniquement: true,
    },
  },
];
